import { QueryClient } from '@tanstack/react-query'
import Keycloak from 'keycloak-js'

export const logout = async (client: QueryClient, keycloak: Keycloak) => {
  client.clear()
  sessionStorage.clear()
  localStorage.clear()
  await keycloak.logout({ redirectUri: window.location.origin })
}
